import { Config } from "@master/css";
// https://ant.design/docs/spec/colors
import { presetPalettes } from "@ant-design/colors";

type Colors = {
  [key: string]: string | Colors;
};

const semanticColors = {
  primary: presetPalettes.blue.primary!,
  secondary: presetPalettes.cyan[7],
  success: presetPalettes.green[6],
  warning: presetPalettes.gold[6],
  error: presetPalettes.red[6],
  disabled: presetPalettes.grey[0],
};

export const masterConfig: Config = {
  colors: {
    ...semanticColors,
    ...Object.keys(presetPalettes).reduce((colorObj, color) => {
      colorObj[color] = Object.fromEntries(
        Object.entries(presetPalettes[color])
      );
      return colorObj;
    }, {} as Colors),
  },
  classes: {
    ant: {
      input:
        "{fg:disabled;b:1|solid|transparent;shadow:none:focus;cursor:default}[readonly] {color:black/.6}[disabled]",
    },
    ellipsis: "text-overflow:ellipsis white-space:nowrap overflow:hidden",
    "has-summary": [
      "bg:#fafafa_.ant-table-summary_table r:0_.ant-table-summary_table",
      "bg:#fafafa_.ant-table-summary_tfoot",
      "{position:sticky;bottom:-16;z:4;h:40;m:0!;pr:4;ai:center;bg:white;rb:8}_.ant-table-pagination",
    ].join(" "),
  },
};
